import { ServiceCollectionPricingHero } from '@/libraries/design/components/collection-pricing-hero/src/service-collection-pricing-hero.tsx';
import { StrategyCollectionPricingHero } from '@/libraries/design/components/collection-pricing-hero/src/strategy-collection-pricing-hero.tsx';
import { TeamworkCollectionPricingHero } from '@/libraries/design/components/collection-pricing-hero/src/teamwork-collection-pricing-hero.tsx';
export interface UniformCollectionPricingHeroProps {
	collectionType: string;
}

const UniformCollectionPricingHero = (props: UniformCollectionPricingHeroProps) => {
	if (props.collectionType === 'teamwork') {
		return <TeamworkCollectionPricingHero />;
	}
	if (props.collectionType === 'strategy') {
		return <StrategyCollectionPricingHero />;
	}

	if (props.collectionType === 'service') {
		return <ServiceCollectionPricingHero />;
	}

	return null;
};

export default UniformCollectionPricingHero;
